<template>
  <form v-loading="form.processing" class="request-folio-form" @submit.prevent="handleFormSubmit">
    <form-group
      for-id="printed_at"
      label="Fecha de Receta"
      :errors="errorDetails"
      :required="true">
      <el-date-picker
        id="printed_at"
        v-model="form.data.printed_at"
        type="date"
        :picker-options="pickerOptions"
        placeholder="Fecha de prescripción" />
    </form-group>
    <form-group
      v-if="isMedicalCenter"
      for-id="organization_rut"
      label="Rut Centro Salud"
      :required="true"
      :errors="errorDetails">
      <app-rut-input
        id="organization_rut"
        v-model="form.data.organization_rut"
        class="form-control" />
    </form-group>
    <form-group
      for-id="practitioner_run"
      label="Run Prescriptor"
      :errors="errorDetails"
      :required="true">
      <app-rut-input
        id="practitioner_run"
        v-model="form.data.practitioner_run"
        class="form-control" />
    </form-group>
    <form-group
      for-id="patient_run"
      label="Run Paciente"
      :errors="errorDetails"
      :required="true">
      <app-rut-input
        id="patient_run"
        v-model="form.data.patient_run"
        class="form-control" />
    </form-group>
    <form-group
      for-id="folio"
      label="Folio"
      :errors="errorDetails"
      :required="true">
      <app-folio-input
        id="folio"
        v-model="form.data.folio" />
    </form-group>
    <form-group for-id="retained" label="" class="request-folio-form__retained-form-group">
      <el-switch
        id="retained"
        v-model="form.data.retained"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="Es receta retenida"
        @input="handleRetainedInput" />
    </form-group>
    <div v-if="form.data.retained" class="request-folio-form__retained-details">
      <form-group
        for-id="retained_type"
        label="Tipo de retención"
        :errors="errorDetails">
        <el-radio-group v-model="form.data.retained_type" @input="handleRetainedTypeInput">
          <el-radio label="retained">
            Retenida
          </el-radio>
          <el-radio label="stock">
            Retenida con control de Stock
          </el-radio>
        </el-radio-group>
      </form-group>
      <form-group
        v-if="form.data.retained_type === 'retained'"
        for-id="retained_amount"
        label="Tipo de dispensación"
        :errors="errorDetails">
        <el-radio-group v-model="form.data.retained_amount">
          <el-radio label="full">
            Completa
          </el-radio>
          <el-radio label="partial">
            Parcial
          </el-radio>
        </el-radio-group>
      </form-group>
    </div>
    <div v-if="errorMessage" class="alert alert-danger">
      {{ errorMessage }}
    </div>
    <el-button native-type="submit" :loading="form.processing" class="btn btn-primary btn-block">
      Validar
    </el-button>
    <el-dialog
      :title="`Prescripción Actualizada`"
      :visible="showPrescriptionDialog"
      width="80%"
      class="request-folio-form__dialog"
      :before-close="handleCloseFormMessageDialog">
      <div class="request-folio-form__dialog-body text-center">
        <div>
          <i class="fas fa-check-circle" />
        </div>
        <h4>La Prescripción ha sido actualizada exitosamente</h4>
      </div>
      <span slot="footer" class="request-folio-form__dialog-footer">
        <el-button type="warning" @click="handleCloseFormMessageDialog"><i class="fas fa-times" /> Cerrar</el-button>
      </span>
    </el-dialog>
  </form>
</template>

<script>
import FormGroup from '../FormGroup';
import AppFolioInput from '@/components/AppFolioInput';
import AppRutInput from '@/components/AppRutInput';
import ErrorHelper from '@/helpers/error';
import _get from 'lodash/get';

export default {
  name: 'RequestFolioForm',
  components: {
    AppRutInput,
    AppFolioInput,
    FormGroup
  },
  props: {
    isMedicalCenter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        data: {
          folio: '',
          printed_at: new Date(),
          practitioner_run: null,
          organization_rut: null,
          patient_run: null,
          retained: false,
          retained_type: null,
          retained_amount: null
        },
        errors: {},
        processing: false
      },
      successResponse: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  computed: {
    errorMessage() {
      return _get(this.form, 'errors.form');
    },
    errorDetails() {
      return this.form.errors || {};
    },
    showPrescriptionDialog() {
      return this.successResponse;
    }
  },
  watch: {
    isMedicalCenter(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form.errors = {};
      }
    }
  },
  methods: {
    handleFormSubmit() {
      this.form.processing = true;
      this.form.errors = {};
      this.successResponse = false;
      const formData = JSON.parse(JSON.stringify(this.form.data));
      if (!this.isMedicalCenter) {
        delete formData.organization_rut;
      }
      this.$store.dispatch('changeFolioStatus', formData)
        .then(response => {
          this.$parent.success(this.form.data.folio);
        })
        .catch(errors => {
          this.form.errors = ErrorHelper.mapErrorFields(errors, {
            dispenser_id: 'dispenser_run',
            patient_id: 'patient_run',
            practitioner_id: 'practitioner_run'
          });
        })
        .finally(() => {
          this.form.processing = false;
        });
    },
    handleCloseFormMessageDialog() {
      this.successResponse = false;
    },
    handleRetainedInput(retained) {
      if (!retained) {
        this.form.data.retained_type = null;
        this.form.data.retained_amount = null;
      } else {
        this.form.data.retained_type = 'retained';
        this.form.data.retained_amount = 'full';
      }
    },
    handleRetainedTypeInput(retainedType) {
      if (retainedType === 'stock') {
        this.form.data.retained_amount = null;
      } else {
        this.form.data.retained_amount = 'full';
      }
    }
  }
};
</script>

<style lang="scss">
.request-folio-form {
  &__retained-form-group {
    display: flex;
    flex-direction: column;

    .el-switch {
      margin-bottom: $--spacing-4;
    }
  }

  &__retained-details {
    padding: $--spacing-4 $--spacing-4 $--spacing-2 $--spacing-4;
    margin-top: -$--spacing-4;
    margin-bottom: $--spacing-4;
    border: 1px solid $--border-color;
    border-radius: $--border-radius-base;

    .form-group {
      > label {
        display: block;
      }
    }
  }

  &__dialog-body {
    .fas {
      color: $--color-green;
      font-size: 6rem;
      margin-bottom: $--spacing-4;
    }
  }
}
</style>
